// Shared linking flag. useIdentityGuard sets it true while claim_identity
// runs (right after SIGNED_IN), and false when it completes. AuthGuard,
// useUserRole, and InstanceContext subscribe so they don't redirect or
// fire dependent queries mid-link.

type Listener = (linking: boolean) => void;

let linking = false;
const listeners = new Set<Listener>();

export function isLinkingNow() {
  return linking;
}

export function setLinking(next: boolean) {
  if (linking === next) return;
  linking = next;
  listeners.forEach((l) => l(linking));
}

export function subscribeLinking(l: Listener) {
  listeners.add(l);
  l(linking);
  return () => {
    listeners.delete(l);
  };
}
